/**
 * Vehicles tab model (#2201).
 *
 * The fleet and the make list are two views of the same data, so they share one
 * page and one `vehicles.read` permission (enforced at the route). There is no
 * per-tab permission clamping — just a resolve-or-default function, so a
 * crafted `?tab=` value cannot land MUI's Tabs on an unmatched value and leave
 * the page blank.
 */

export type VehicleTab = 'vehicles' | 'makes';

/**
 * Resolve a requested (URL) tab, defaulting to 'vehicles' for a missing or
 * unrecognized value.
 */
export function resolveVehicleTab(requested: string | null): VehicleTab {
  return requested === 'makes' ? 'makes' : 'vehicles';
}
